import { useMemo } from 'react';
import DOMPurify from 'dompurify';
import './richContent.css';

// Forzar target/rel seguros en los links del contenido enriquecido.
let hookRegistered = false;
function ensureHook() {
  if (hookRegistered || typeof window === 'undefined') return;
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.getAttribute('href')) {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
  hookRegistered = true;
}

// ¿El HTML del editor está vacío? (Quill deja "<p><br></p>" al borrar todo)
export function isEmptyHtml(html) {
  if (!html) return true;
  const stripped = html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, '')
    .replace(/\s/g, '');
  return stripped.length === 0;
}

// Texto plano a partir de HTML (para thumbnails / previews chicos).
export function stripHtml(html = '') {
  if (typeof document === 'undefined') return html.replace(/<[^>]*>/g, ' ');
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
}

// El contenido pegado desde Word/Docs/Notion suele traer un espacio duro
// (&nbsp;) entre cada palabra. Para el navegador el párrafo entero pasa a ser
// una sola palabra sin puntos de corte, y termina partiéndola por la mitad.
// Los pasamos a espacios normales (solo en los nodos de texto, ya sanitizado).
function unNbsp(html) {
  if (!html || (!html.includes('\u00a0') && !html.includes('&nbsp;'))) return html;
  const tpl = document.createElement('template');
  tpl.innerHTML = html;
  const walker = document.createTreeWalker(tpl.content, NodeFilter.SHOW_TEXT);
  while (walker.nextNode()) {
    walker.currentNode.nodeValue = walker.currentNode.nodeValue.replace(/\u00a0/g, ' ');
  }
  return tpl.innerHTML;
}

export function RichContent({ html, style, linkColor }) {
  ensureHook();
  const clean = useMemo(
    () => unNbsp(DOMPurify.sanitize(html || '', { ADD_ATTR: ['target'] })),
    [html]
  );
  return (
    <div
      className="rich-content"
      style={{ ...(linkColor ? { '--rich-link': linkColor } : {}), ...style }}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
